export const useHelpDrawer = () => {
  const visible = useState('help-drawer', () => false)

  function open() {
    visible.value = true
  }
  function close() {
    visible.value = false
  }

  function toggle() {
    visible.value = !visible.value
  }

  return {
    open,
    close,
    toggle,
    visible,
  }
}
